/* Ayudate · Preparación de la foto de perfil */

/* ------------------------------------------------------------------
   Reduce la foto en el navegador antes de enviarla.
   Una foto de celular pesa entre 3 y 12 MB; para un avatar de 46 px
   sobra con 512 px de lado. Así nadie choca contra un límite y lo que
   viaja son unos 40 KB en vez de varios megas.
------------------------------------------------------------------- */
export const LADO_FOTO = 512;
export const PESO_MAXIMO = 12 * 1024 * 1024;   // 12 MB de entrada

export async function prepararFoto(archivo) {
  if (!archivo.type.startsWith("image/"))
    throw new Error("Ese archivo no es una imagen.");
  if (archivo.size > PESO_MAXIMO)
    throw new Error("La imagen pesa más de 12 MB. Pruebe con otra.");

  const url = URL.createObjectURL(archivo);
  try {
    const img = await new Promise((ok, mal) => {
      const i = new Image();
      i.onload = () => ok(i);
      i.onerror = () => mal(new Error("No pudimos leer la imagen."));
      i.src = url;
    });

    // Recorte cuadrado centrado
    const lado = Math.min(img.width, img.height);
    const sx = (img.width - lado) / 2;
    const sy = (img.height - lado) / 2;

    const lienzo = document.createElement("canvas");
    lienzo.width = lienzo.height = LADO_FOTO;
    const ctx = lienzo.getContext("2d");
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, sx, sy, lado, lado, 0, 0, LADO_FOTO, LADO_FOTO);

    const tipo = lienzo.toDataURL("image/webp", 0.82).startsWith("data:image/webp")
      ? "image/webp" : "image/jpeg";
    return lienzo.toDataURL(tipo, 0.82);
  } finally {
    URL.revokeObjectURL(url);
  }
}
